/**
 * accordionPane
 */

// Module dependencies
import 'protons';

// Module styles
import './_accordion-pane.scss';

// Module template
import './_accordion-pane.twig';

export const name = 'accordionPane';

export const defaults = {
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { accordionPane = {} }) {
  const accordionPanes = [...$('.accordion-pane', $context)];

  if (accordionPanes.length) {
    accordionPanes.forEach(accordionPane => {
      const heading = accordionPane.querySelector('.accordion-pane__heading');
      const content = accordionPane.querySelector('.accordion-pane__content');
      const contentHeight = content.offsetHeight;

      // Check if CSS supports variables
      if (window.CSS && CSS.supports('color', 'var(--fake-var)') && contentHeight) {
        // We want to animate the specific max-height of the content so we pass it to a CSS variable
        // Content height + 24px for lineheight and 16px for margin on <p> tags
        // Multiply content height by 2 because PL is unreliable with offsetHeight
        content.style.setProperty('--max-height', (contentHeight * 2 + 24 + 16) + 'px');
        // This calculation should make up for line-height
      }
      // Then remove the active class from the accordions
      // if JS is disabled content from accordions is still visible
      if (heading && content) {
        heading.classList.remove('active');
        content.classList.remove('active');
        content.classList.remove('visible');
        // Add correct attributes for accessibility
        content.setAttribute('aria-expanded', false);
        content.setAttribute('aria-hidden', true);

        // Add click event listener to toggle
        heading.addEventListener('click', function(e){
          heading.classList.toggle('active');
          content.classList.toggle('active');

          // Add correct attributes for accessibility
          if (heading.classList.contains('active')) {
            content.setAttribute('aria-expanded', true);
            content.setAttribute('aria-hidden', false);
            heading.setAttribute('aria-pressed', true);
          } else {
            content.setAttribute('aria-expanded', false);
            content.setAttribute('aria-hidden', true);
            heading.setAttribute('aria-pressed', false);
          }
        });
      }
    });
  }
}

export default enable;
